import AppService from '../../services/app.service';

export default class MedialibraryModel {
    id: number;
    name: string;
    description: string;
    alt: string;
    url: string;
    ext: string;
    height: number;
    width: number;
    size: number;
    files: any;
    ref: string;
    field: string;
    refid: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.caption;
        this.alt = datarow.alt;
        this.url = datarow.url;
        this.ext = datarow.ext;
        this.height = datarow.height;
        this.width = datarow.width;
        this.size = datarow.size;
        this.files= datarow.files;
        this.ref= datarow.ref;
        this.field= datarow.field;
        this.refid= datarow.refid;
    } 

    public static endPoint: string = 'upload';
    public static endPoint2: string = 'upload/files/';
    public static endPointFilter = '?populate=*&sort=name&filters[alternativeText]=' +AppService.appId();
    public static url: string = '/medialibrary';
    public static caption: string = 'Media Library';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        alt:  '',
        url:  '',
        ext:  '',
        height:  0,
        width: 0,
        size: 0,
        files: null,
        ref: '',
        field: '',
        refid: '',
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'url', caption: '', type:'media' },
    ]

    public static columnPicklist = [
        { name: 'description', caption: 'Description' },
        { name: 'url', caption: '', type:'media' },
    ]

}